// TODO: Read up on this cache implementation is it in memory or indexeddb?
// Localtion is also not great.
// TODO: Typesafe IO implementation!
import { Cache } from "../../../../infra3d/utils/cache";
import { CaptureSystem } from "../capturesystem";
import { Frame } from "./frame";
import { FrameDataMeta } from "../framedatameta";
import { fetchAllData, fetchData, fetchDataAsGeoJSON, fetchAllDataAsGeoJSON, notnestedframefields } from "../util";
import proj4 from "proj4";
import { propertyFilter } from "../projectscope";
function cacheKeyFrame(id, collection) {
    return `get(${id},${collection})`;
}
export class FrameProviderFramerV2 {
    constructor(apiHost, authObject, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
        this._cache = new Cache(cacheSize, false);
    }
    allSequence(collection, stream, onSuccess, onError) {
        const cacheKey = `allStream(${collection}, ${stream})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        stream = stream.split("/")[1];
        const error = new Error("Data is invalid.");
        const _propertyFilter = propertyFilter("frame", { stream: stream });
        const url = `${this._apiHost.href}/frames/${collection}?${_propertyFilter}&${notnestedframefields()}&limit=2000`;
        const return_frames = (full_frames) => {
            const res = [];
            for (const frame of full_frames) {
                if (frame === undefined) {
                    // FIXME: Why, this should never be the case.
                    continue;
                }
                if (!Frame.isValid(frame)) {
                    onError(error);
                    return;
                }
                const _frame = Frame.create(frame, collection);
                this._cache.setItem(cacheKeyFrame(frame.id, collection), _frame, null);
                res.push(_frame);
            }
            this._cache.setItem(cacheKey, res, null);
            onSuccess(res);
        };
        // FIXME: TRY
        fetchAllData(fetchData, url, "GET", (frames) => {
            if (frames === undefined || !Array.isArray(frames)) {
                onError(error);
                return;
            }
            this._fetchAllCapturesystems(frames, collection, (capturesystem_filled_frames) => {
                this._fetchAllCampaigns(capturesystem_filled_frames, collection, (campaign_filled_frames) => {
                    this._fetchAllFrameDataMetas(campaign_filled_frames, collection, return_frames, onError);
                }, onError);
            }, onError);
        }, onError, this._apiHost.origin, this._authObject);
    }
    allWithin(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        const cacheKey = `allWithin(${collection}, ${minEasting}, ${maxEasting}, ${maxNorthing}, ${maxNorthing}, ${epsg})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const _propertyFilter = propertyFilter("frame", {
            within: {
                minEasting: minEasting,
                maxEasting: maxEasting,
                minNorthing: minNorthing,
                maxNorthing: maxNorthing,
                epsg: epsg,
            },
        });
        const url = `${this._apiHost.href}/frames/${collection}?${_propertyFilter}`;
        fetchAllData(fetchData, url, "GET", (frames) => {
            if (frames === undefined || !Array.isArray(frames)) {
                onError(error);
                return;
            }
            const res = [];
            for (const frame of frames) {
                if (!Frame.isValid(frame)) {
                    onError(error);
                    return;
                }
                const _frame = Frame.create(frame, collection);
                this._cache.setItem(cacheKeyFrame(frame.id, collection), _frame, null);
                res.push(_frame);
            }
            this._cache.setItem(cacheKey, res, null);
            onSuccess(res);
        }, onError, this._apiHost.origin, this._authObject);
    }
    allWithinAsGeoJSON(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, skip, limit, onSuccess, onError) {
        const cacheKey = `allWithinAsGeoJSON(${collection}, ${minEasting}, ${maxEasting}, ${maxNorthing}, ${maxNorthing}, ${epsg}, ${skip})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const _propertyFilter = propertyFilter("frame", {
            within: {
                minEasting: minEasting,
                maxEasting: maxEasting,
                minNorthing: minNorthing,
                maxNorthing: maxNorthing,
                epsg: epsg,
            },
        });
        const url = `${this._apiHost.href}/frames/${collection}?${_propertyFilter}&skip=${skip}&srid=${epsg}&fields=id,streamtype,timestamp,stream,framenumber,segment,campaignID,properties&limit=${limit}`;
        fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "GET", (geojson) => {
            this._cache.setItem(cacheKey, geojson, null);
            console.log(geojson);
            onSuccess(geojson);
        }, onError, this._apiHost.origin, this._authObject);
    }
    // TODO: TRY since its the same as capturesystemprovider as other gets.
    get(collection_fallback, key, onSuccess, onError) {
        const key_array = key.split("/");
        let collection = collection_fallback;
        let id = key;
        if (key_array.length == 2) {
            collection = key_array[0];
            id = key_array[1];
        }
        const cacheKey = cacheKeyFrame(id, collection_fallback);
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/frames/${collection}/${id}`;
        fetchData(url, "GET", (data) => {
            if (!Frame.isValid(data)) {
                onError(error);
                return;
            }
            if (proj4.defs[`EPSG:${data.epsg}`]) {
                const res = Frame.create(data, collection);
                this._cache.setItem(cacheKey, res, null);
                onSuccess(res);
            }
            else {
                fetch(`https://epsg.io/${data.epsg}.proj4`)
                    .then((response) => {
                    response
                        .text()
                        .then((projdef) => {
                        proj4.defs(`EPSG:${data.epsg}`, projdef);
                        const res = Frame.create(data, collection);
                        this._cache.setItem(cacheKey, res, null);
                        onSuccess(res);
                    })
                        .catch(onError);
                })
                    .catch((reason) => {
                    onError(`Could not load EPSG:${data.epsg}`);
                });
            }
        }, onError, this._authObject);
    }
    findNearest(collection, easting, northing, epsg, onSuccess, onError) {
        const cacheKey = `findNearest(${collection}, ${easting}, ${northing}, ${epsg})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/frames/${collection}/knn?easting=${easting}&northing=${northing}&srid=${epsg}`;
        fetchAllData(fetchData, url, "GET", (frames) => {
            if (frames === undefined || !Array.isArray(frames)) {
                onError(error);
                return;
            }
            const processFrames = () => {
                const res = [];
                for (const frame of frames) {
                    if (!Frame.isValid(frame)) {
                        onError(error);
                        return;
                    }
                    const _frame = Frame.create(frame, collection);
                    this._cache.setItem(cacheKeyFrame(frame.id, collection), _frame, null);
                    res.push(_frame);
                }
                this._cache.setItem(cacheKey, res, null);
                onSuccess(res);
            };
            if (proj4.defs[`EPSG:${frames[0].epsg}`]) {
                processFrames();
            }
            else {
                fetch(`https://epsg.io/${frames[0].epsg}.proj4`)
                    .then((response) => {
                    response
                        .text()
                        .then((projdef) => {
                        proj4.defs(`EPSG:${frames[0].epsg}`, projdef);
                        processFrames();
                    })
                        .catch(onError);
                })
                    .catch((reason) => {
                    onError(`Could not load EPSG:${frames[0].epsg}`);
                });
            }
        }, onError, this._apiHost.origin, this._authObject);
    }
    getCapturesystem(collection, id, onSuccess, onError) {
        const cacheKey = `getCapturesystem(${collection}, ${id})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/capturesystems/${collection}/${id}`;
        fetchData(url, "GET", (data) => {
            if (!CaptureSystem.isValid(data)) {
                onError(error);
                return;
            }
            this._cache.setItem(cacheKey, data, null);
            onSuccess(data);
        }, onError, this._authObject);
    }
    _fetchAllCapturesystems(common_frames, collection, success, onError) {
        if (common_frames.length > 0) {
            this.getCapturesystem(collection, common_frames[0].capturesystemID, (capturesystem_payload) => {
                const res_full = [];
                for (const frame of common_frames) {
                    frame.capturesystem = capturesystem_payload;
                    res_full.push(frame);
                }
                success(res_full);
            }, onError);
        }
        else {
            success(common_frames);
        }
    }
    getFramedatameta(collection, id, onSuccess, onError) {
        const cacheKey = `getFramedatameta(${collection}, ${id})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/framedatametas/${collection}/${id}`;
        fetchData(url, "GET", (data) => {
            if (!FrameDataMeta.isValid(data)) {
                onError(error);
                return;
            }
            this._cache.setItem(cacheKey, data, null);
            onSuccess(data);
        }, onError, this._authObject);
    }
    _fetchAllFrameDataMetas(common_frames, collection, success, onError) {
        if (common_frames.length > 0) {
            this.getFramedatameta(collection, common_frames[0].framedatametaID, (framedatameta_payload) => {
                const res_full = [];
                for (const frame of common_frames) {
                    frame.framedatameta = framedatameta_payload;
                    res_full.push(frame);
                }
                success(res_full);
            }, onError);
        }
        else {
            success(common_frames);
        }
    }
    getCampaign(collection, id, onSuccess, onError) {
        const cacheKey = `getCampaign(${collection}, ${id})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/campaigns/${collection}/${id}`;
        fetchData(url, "GET", (data) => {
            this._cache.setItem(cacheKey, data, null);
            onSuccess(data);
        }, onError, this._authObject);
    }
    _fetchAllCampaigns(common_frames, collection, success, onError) {
        if (common_frames.length > 0) {
            this.getCampaign(collection, common_frames[0].campaignID, (campaign_payload) => {
                const res_full = [];
                for (const frame of common_frames) {
                    frame.campaign = campaign_payload;
                    res_full.push(frame);
                }
                success(res_full);
            }, onError);
        }
        else {
            success(common_frames);
        }
    }
    clearCache() {
        this._cache.clear();
    }
    set authObject(authObject) {
        this._authObject = authObject;
    }
}
//# sourceMappingURL=frameprovider.js.map